import styled from 'styled-components'

const DesktopMenuStyle = styled.nav`
	--headerIconsContMarginLeft: var(--sp5x);
	--headerIconsPadding: var(--sp1x);
	--languageSwitcherMarginLeft: var(--sp4x);

	display: inline-flex;
	align-items: center;

	.menu-cont {
		display: flex;
		align-self: stretch;
		align-items: center;
	}

	.header-icons-cont {
		margin-left: var(--headerIconsContMarginLeft);

		.icon-cont {
			display: inline-flex;
			padding: var(--headerIconsPadding);
			transition: color var(--trTime);

			.link-item {
				display: inline-flex;

				[class^='giz-'] {
					line-height: 1;
				}
			}

			@media only screen and (hover: hover) {
				&:hover {
					color: var(--primaryColor2);
				}
			}
		}
	}

	.events-button {
		margin-left: var(--headerIconsContMarginLeft);
	}

	.language-switcher {
		margin-left: var(--languageSwitcherMarginLeft);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--headerIconsContMarginLeft: var(--sp4x);
		--languageSwitcherMarginLeft: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--headerIconsContMarginLeft: var(--sp3x);
		--languageSwitcherMarginLeft: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--headerIconsContMarginLeft: var(--sp3x);
		--languageSwitcherMarginLeft: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--headerIconsContMarginLeft: var(--sp1-5x);
		--languageSwitcherMarginLeft: var(--sp1-5x);
	}
`

export default DesktopMenuStyle
